import getReducerHandler from '../../providers/getReducerHandler'
import handleReducerSimpleSetter from '../../providers/handleReducerSimpleSetter'

/*
 * --- INDIVIDUAL ACTION HANDLERS ---
 * (Set multiple values & merge/processing logic only, otherwise use handleReducerSimpleSetter)
 */

const handleUpdateStoryPageState = (state, action) => {
  const url = new URL(window.location.href)
  if (action.value) {
    url.searchParams.set('completed', action.value)
  } else {
    url.searchParams.delete('completed')
  }
  window.history.pushState({}, '', url)
  return {
    ...state,
    storyPage: { activePersonId: action.value },
  }
}

// --- Handlers registry ---
const handlers = {
  UPDATE_STORY_PAGE_STATE: handleUpdateStoryPageState,
  UPDATE_SELECTED_FILTER: handleReducerSimpleSetter,
}

export const stateReducer = (state, action) => getReducerHandler(state, action, handlers)
export const _ = ''
